import { render, staticRenderFns } from "./yxdealer.vue?vue&type=template&id=cad4b24e&scoped=true&"
import script from "./yxdealer.vue?vue&type=script&lang=js&"
export * from "./yxdealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad4b24e",
  null
  
)

export default component.exports